import {Component} from 'react'
import {Link} from 'react-router-dom'
import './index.css'

class Navbar extends Component {
  render() {
    return (
      <div className="navbar-container">
        <h1 className="heading">PORTFOLIO</h1>
        <div className="nav-items">
          <li className="item">
            <Link to="/"> Home </Link>
          </li>
          <li className="item">
            <Link to="/projects"> Projects </Link>
          </li>
          <li className="item">
            <Link to="/about"> About </Link>
          </li>
        </div>
      </div>
    )
  }
}

export default Navbar
